import './_styles.scss';
import React from 'react';
import Header from './Header';
import { connect } from 'react-redux';
import PaymentMethod from './_payment';
import Cookies from 'universal-cookie';
import ContactInformation from './_contact';
import ShippingInformation from './_shipping';
import { actions, selectors } from 'redux-store';

class CheckoutForm extends React.Component {

  constructor(props) {

    super(props);

    this.cookies = new Cookies();

    this.state = {

      authenticated: false,
      loading: false,

      order_id: '',

      step: 1,

      errors: {},

      phone_no: '',
      email_address: '',

      city: '',
      location: '',
      address_2: '',
      last_name: '',
      first_name: '',

      delivery: this.deliveryMethods(),
      delivery_method: {},

    }
  }

  componentDidMount = () => {

    const { uid, logged_out } = this.cookies.get('session_data');

    return this.update_state('authenticated',(!!uid && logged_out!==true));

  }

  componentWillReceiveProps = (props) => {
    if (!props.invoice) return null;
    this.setState({ order_id: props.invoice });
  }

  deliveryMethods = () => ([
    { name: 'Self', caption: 'Self Pickup', charge: 0 },
    { name: 'Today', caption: 'Same Day Delivery', charge: 500 },
    { name: 'Daily', caption: 'Overnight Delivery', charge: 300 },
    { name: 'Weekly', caption: 'Weekly Delivery', charge: 150 },
  ]);

  updateDelivery = (method) => {

    const { name } = method;

    const { delivery, delivery_method } = this.state;

    const same_method = name === delivery_method.name;

    const valid_method = (!same_method && delivery.includes(method));

    return (!valid_method) ? null: this.update_state('delivery_method',method);

  }

  handleChange = (e) => {

    const { errors } = this.state;

    const { type, name, value, checked } = e.target;

    this.setState({ errors: {...errors, [name] : null} });

    return this.update_state(name,(type === 'checkbox') ? checked : value);

  }

  update_state = (name,value) => this.setState({ [name]: value },
    () => this.props.update_parent(this.state)
  );

  handleProgress = (increment = true) => {

    const { step } = this.state;

    const new_Step = (!!increment) ? step+1 : step-1;

    return this.setState({ step: new_Step });

  }

  handleErrors = (e) => {
    this.setState({ errors: e });
    window.scrollTo({ top: 0 });
  }

  handleForm = (e) => e.preventDefault();

  render() {

    return (
      <div className='Checkout-Form-Wrapper'>

        <form
          noValidate
          method='POST'
          autoComplete='off'
          className='Checkout-Form'
          onSubmit={this.handleForm}>

          <Header
            step={this.state.step}
            total={this.props.order_total}
          />

          <ContactInformation
            values={this.state}
            onError={this.handleErrors}
            onSubmit={this.handleProgress}
            onChangeEvent={this.handleChange}
          />

          <ShippingInformation
            values={this.state}
            data={this.state.delivery}
            onError={this.handleErrors}
            onSubmit={this.handleProgress}
            onChangeEvent={this.updateDelivery}
          />

          <PaymentMethod
            values={this.state}
            cart={this.props.cart}
            onSubmit={this.update_state}
            total={this.props.order_total}
            navigateBack={this.handleProgress}
          />

        </form>

      </div>
    )
  }
}

const mapStateToProps = ({ cart, cache }) => ({
  cart: cart.cart_items,
  products: cache.product_list,
  order_total: selectors.cart_total(cart)
});

export default  connect(mapStateToProps,{...actions})(CheckoutForm);
